import $foreign from "./foreign.cjs";
var boolConj = $foreign.boolConj;
var boolDisj = $foreign.boolDisj;
var boolNot = $foreign.boolNot;
export { boolConj, boolDisj, boolNot };
